import fetchClient from "api/client";
import INSIGHTS_ENDPOINT from "./insightsEndpoint";
/**
 * @description PATCH api/insights/:id/review
 * */
export default function patchInsightsReview({ id, ...body }) {
  return fetchClient.patch(`${INSIGHTS_ENDPOINT}/${id}/review`, { body });
}
